import {defineStore} from "pinia";
import {computed, type Ref, ref, shallowRef} from "vue";
import BasicCompanyDetails from "@/components/slides/BasicCompanyDetails.vue";
import CompanyMetricAndPreferences from "@/components/slides/CompanyMetricAndPreferences.vue";
import UserAccountSetup from "@/components/slides/UserAccountSetup.vue";
import RegistrationComplete from "@/components/slides/RegistrationComplete.vue";
import DuplicateEmail from "@/components/slides/DuplicateEmail.vue";
import {useRegistrationStore} from "@/stores/registration.ts";
import VerifyPhone from "@/components/slides/VerifyPhone.vue";
import PhoneVrified from "@/components/slides/PhoneVerified.vue";
import LeadPrices from "@/components/slides/LeadPrices.vue";

export const SLIDES = {
    BASIC_COMPANY_DETAILS: 'basic_company_details',
    COMPANY_METRIC_AND_PREFERENCES: 'company_metric_and_preferences',
    USER_ACCOUNT_SETUP: 'user_account_setup',
    REGISTRATION_COMPLETE: 'registration_complete',
    DUPLICATE_EMAIL: 'duplicate_email',
    VERIFY_PHONE: 'verify_phone',
    PHONE_VERIFIED: 'phone_verified',
    LEAD_PRICES: 'lead_prices',
}
export const useSlidesStore = defineStore('slides', () => {
    const currentSlide: Ref<string> = ref(SLIDES.BASIC_COMPANY_DETAILS);
    const componentMap = shallowRef({
        [SLIDES.BASIC_COMPANY_DETAILS]: BasicCompanyDetails,
        [SLIDES.COMPANY_METRIC_AND_PREFERENCES]: CompanyMetricAndPreferences,
        [SLIDES.USER_ACCOUNT_SETUP]: UserAccountSetup,
        [SLIDES.REGISTRATION_COMPLETE]: RegistrationComplete,
        [SLIDES.DUPLICATE_EMAIL]: DuplicateEmail,
        [SLIDES.VERIFY_PHONE]: VerifyPhone,
        [SLIDES.PHONE_VERIFIED]: PhoneVrified,
        [SLIDES.LEAD_PRICES]: LeadPrices,
    });

    const registrationStore = useRegistrationStore();

    const hideNextButton = computed(() => {
        return [
            SLIDES.REGISTRATION_COMPLETE,
            SLIDES.DUPLICATE_EMAIL,
            SLIDES.VERIFY_PHONE,
            SLIDES.PHONE_VERIFIED,
        ].includes(currentSlide.value);
    });
    const hideBackButton = computed(() => {
        //todo: implement when needed
        return true;
    });

    const nextSlide = (slide?: string) => {
        if (slide) {
            currentSlide.value = slide;
            return;
        }

        switch (currentSlide.value) {
            case SLIDES.BASIC_COMPANY_DETAILS:
                if (!registrationStore.registeringCompany.emailCanLogin) {
                    currentSlide.value = SLIDES.DUPLICATE_EMAIL;
                } else {
                    currentSlide.value = SLIDES.VERIFY_PHONE;
                }

                break;
            case SLIDES.VERIFY_PHONE:
                currentSlide.value = SLIDES.PHONE_VERIFIED;
                break;
            case SLIDES.USER_ACCOUNT_SETUP:
                currentSlide.value = SLIDES.LEAD_PRICES;
                break;
            case SLIDES.LEAD_PRICES:
                currentSlide.value = SLIDES.REGISTRATION_COMPLETE;
                break;
        }
    }

    const previousSlide = () => {
        //todo: implement when needed
    }

    return {
        currentSlide,
        componentMap,
        hideNextButton,
        hideBackButton,
        nextSlide,
        previousSlide
    }
});
